export default "__VITE_ASSET__C8yS3ttZ__"